import gql from 'graphql-tag';

// todo: Complete this
export function startWorkflowMutation() {
  return gql(`
    mutation StartProcess($params: StartProcessInput!) {
      startProcess(params: $params) {
        id
        taskIds
      }
    }
  `);
}
export function requestWorkflowMutation() {
  return gql(`
    mutation StartProcess($mobileUserConfigId: Int!) {
      startProcess: requestProcess(mobileUserConfigId: $mobileUserConfigId) {
        id
        taskIds
      }
    }
  `);
}
